import { render, staticRenderFns } from "./EquipeResponsaveisComponent.vue?vue&type=template&id=95729e62"
import script from "./EquipeResponsaveisComponent.vue?vue&type=script&lang=js"
export * from "./EquipeResponsaveisComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports